const NOTIFICATION_TYPE_ID = 4 
const NOTIFICATION_STATUS_ID = 1
const NOTIFICATION_RECIPIENT_TYPE_ID = 1  

export {
  NOTIFICATION_TYPE_ID,
  NOTIFICATION_STATUS_ID,
  NOTIFICATION_RECIPIENT_TYPE_ID,
}